import { render, staticRenderFns } from "./addTagModal.vue?vue&type=template&id=73c0c006&scoped=true"
import script from "./addTagModal.vue?vue&type=script&lang=js"
export * from "./addTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0c006",
  null
  
)

export default component.exports